import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class LogoutService {
  abstract logout$(): Observable<unknown>;

  abstract switchAccount$(): Observable<unknown>;

  dispatchLogout(): void {
    /* intentionally left blank */
  }

  dispatchAccountSwitch(): void {
    /* intentionally left blank */
  }
}

@Injectable({
  providedIn: 'root'
})
export class StandaloneLogoutService extends LogoutService {
  private readonly logout = new Subject<void>();
  private readonly switchAccount = new Subject<void>();

  public dispatchLogout(): void {
    this.logout.next();
  }

  public dispatchAccountSwitch(): void {
    this.switchAccount.next();
  }

  public logout$(): Observable<void> {
    return this.logout.asObservable();
  }

  public switchAccount$(): Observable<void> {
    return this.switchAccount.asObservable();
  }
}
